import { render, staticRenderFns } from "./BroadcastSentView.vue?vue&type=template&id=79bd2653&"
import script from "./BroadcastSentView.vue?vue&type=script&lang=ts&"
export * from "./BroadcastSentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports